import { useTranslation } from 'react-i18next'

import { countriesCurrencies } from '../../lib'
import { numberWithCommas } from '../../utils/common.utils'
import MonetizationIcon from '../../assets/icons/monetization-icon.svg'

const CustomerDetailsPaymentsBriefData = ({ totalAmountPaid, totalPaymentsMade, totalPaymentsMadeThisMonth }: { totalAmountPaid: number; totalPaymentsMade: number; totalPaymentsMadeThisMonth: number }) => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'
  const currency = (countriesCurrencies as { [key: string]: string })[selectedCountry].toUpperCase()

  const { t } = useTranslation(['customer-details-management'])

  return (
    <div className="customer-details-profile-payments-brief-data">
      <div className="customer-details-profile-payments-brief-title">{t('customerDetailsPaymentsBriefData.currentTotalOfPayments', { totalOfPayments: numberWithCommas(totalPaymentsMade) })}</div>
      <div className="customer-details-profile-payments-brief-main-data">
        <div className="customer-details-profile-payments-brief-main-data-icon">
          <img
            src={MonetizationIcon}
            alt="monetization-icon"
          />
        </div>
        <div className="customer-details-profile-payments-brief-main-data-text-container">
          <div className="customer-details-profile-payments-brief-main-data-text-amount">{`$ ${numberWithCommas(totalAmountPaid)}`}</div>
          <div className="customer-details-profile-payments-brief-main-data-text-currency">{currency}</div>
        </div>
      </div>
      <div className="customer-details-profile-payments-brief-last-payments">
        {t('customerDetailsPaymentsBriefData.currentTotalOfPaymentsThisMonth', { totalOfPaymentsThisMonth: numberWithCommas(totalPaymentsMadeThisMonth) })}
      </div>
    </div>
  )
}

export default CustomerDetailsPaymentsBriefData
